import React, { useMemo, useRef } from 'react';
import { DocumentSubCategory, DocumentUploadCategory, PropertyDocument, SUBCATEGORY_LABELS } from 'types/Documents';
import Button from 'components/Button/Button';
import FileTypeIcon from 'components/Icons/FileTypeIcon';
import UploadSvg from 'assets/icons/upload.svg?react';
import BankIcon from 'assets/icons/bank.svg?react';
import { CategoryBadge, DoneBadge } from '../utils';
import { SUPPORTED_FILE_TYPES } from 'utils/documents';
import styles from '../NewOwnerOnboarding.module.css';

interface W9ItemProps {
    category: DocumentUploadCategory | undefined;
    w9Documents: PropertyDocument[];
    uploadDocuments: (e: React.ChangeEvent<HTMLInputElement>, category: DocumentUploadCategory) => Promise<void>;
    disableInteractions: boolean;
}

function W9Item({ category: w9Category, w9Documents, uploadDocuments, disableInteractions }: W9ItemProps): JSX.Element {
    if (!w9Category) return <></>;

    const w9File = useMemo(() => (w9Documents.length > 0 ? w9Documents[0] : null), [w9Documents]);
    const w9InputRef = useRef<HTMLInputElement>(null);

    const handleW9Upload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await uploadDocuments(e, w9Category);
    };

    return (
        <div className={`${styles.item} ${w9File ? styles.done : w9Category.is_required ? styles.required : ''}`}>
            <BankIcon className={styles.itemIcon} />
            <div>
                <div className={styles.titleRow}>
                    <span className={styles.itemTitle}>{SUBCATEGORY_LABELS[DocumentSubCategory.W9]}</span>
                    {w9Category && <CategoryBadge category={w9Category} />}
                </div>
                <p className={styles.itemDescription}>So we can deposit your earnings and file taxes correctly.</p>
            </div>
            <div className={styles.actions}>
                {w9File ? (
                    <DoneBadge />
                ) : (
                    <>
                        <input
                            ref={w9InputRef}
                            type="file"
                            hidden
                            onChange={handleW9Upload}
                            multiple={false}
                            accept={SUPPORTED_FILE_TYPES}
                        />
                        <Button
                            color="primary"
                            size="sm"
                            className={styles.actionButton}
                            onClick={() => w9InputRef.current?.click()}
                            disabled={disableInteractions}
                        >
                            <UploadSvg />
                            Upload
                        </Button>
                    </>
                )}
            </div>

            {w9File && (
                <div className={styles.fileItem}>
                    <FileTypeIcon fileType={w9File.file_type} size={20} />
                    <span className={styles.fileName}>{w9File.display_name}</span>
                </div>
            )}
        </div>
    );
}

export default W9Item;
